import React from 'react';
import { StatsigProvider as StatsigProviderComponent, StatsigUser } from '@statsig/react-bindings';
import { getPageEnvByHost } from '@/utils/environment';

export const StatsigProvider: React.FC<{ user?: StatsigUser }> = ({ user, children }) => {
  return (
    <StatsigProviderComponent
      sdkKey="client-LJmokBKXH96F2ZdI0ZYDyd27hX7Z8HfNU35XJvv3jxa"
      user={user || {}}
      options={{ environment: { tier: getPageEnvByHost() === 'prod' ? 'production' : 'staging' } }}
    >
      {children}
    </StatsigProviderComponent>
  );
};

export default StatsigProvider;
